<script setup>
import { useRoute } from 'vue-router';
import BaseSettingsHeader from 'dashboard/routes/dashboard/settings/components/BaseSettingsHeader.vue';

const route = useRoute();

const TABS = [
  {
    name: 'pipelines_settings_index',
    label: 'CARDS.CRM_SETTINGS.TABS.PIPELINES',
  },
  { name: 'forms_index', label: 'CARDS.CRM_SETTINGS.TABS.FORMS' },
];
</script>

<template>
  <div class="flex flex-col w-full gap-5">
    <BaseSettingsHeader
      :title="$t('CARDS.CRM_SETTINGS.TITLE')"
      :description="$t('CARDS.CRM_SETTINGS.HEADER_DESCRIPTION')"
    />
    <div class="flex flex-wrap items-center justify-between w-full gap-3">
      <nav class="flex items-center gap-1 p-1 rounded-lg bg-n-alpha-2">
        <router-link
          v-for="tab in TABS"
          :key="tab.name"
          :to="{
            name: tab.name,
            params: { accountId: route.params.accountId },
          }"
          class="px-3 py-1.5 text-sm font-medium rounded-md transition-colors"
          :class="
            route.name === tab.name
              ? 'bg-n-solid-1 text-n-slate-12 shadow-sm'
              : 'text-n-slate-11 hover:text-n-slate-12'
          "
          :data-testid="`crm-tab-${tab.name}`"
        >
          {{ $t(tab.label) }}
        </router-link>
      </nav>
      <slot name="actions" />
    </div>
  </div>
</template>
